<div
  *ngIf="privilegeGenerateQRCode || privilegeValidateQR || privilegeGenerateCSV || privilegeEditProduct || privilegeUnpublishedProduct"
  class="d-flex align-items-center position-absolute top-0 end-0 m-9 mt-6"
>
  <a class="btn btn-outline btn-outline-primary ps-7 mb-2" data-kt-menu-attach="parent" data-kt-menu-placement="bottom-end" data-kt-menu-trigger="click" href="#"
    >Actions
    <span class="svg-icon svg-icon-2 me-0">
      <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z"
          fill="currentColor"
        />
      </svg>
    </span>
  </a>
  <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold py-4 w-300px fs-6" data-kt-menu="true">
    <ng-container *ngIf="renderView">
      <div *ngIf="privilegeGenerateQRCode" class="menu-item px-5">
        <a (click)="onClickOpenModalGenerateCode()" class="menu-link">
          <span [inlineSVG]="STRING_CONSTANTS.ICON.IC_QR_CODE" class="svg-icon svg-icon-2 me-3"></span>
          <span>Generate QR Code</span>
        </a>
      </div>
      <div *ngIf="privilegeValidateQR" class="menu-item px-5">
        <a (click)="onClickValidateQr()" class="menu-link">
          <span [inlineSVG]="STRING_CONSTANTS.ICON.IC_BULLET_CLOSE" class="svg-icon svg-icon-2 me-3"></span>
          <span>Validate Qr</span>
        </a>
      </div>

      <div *ngIf="privilegeGenerateCSV" class="menu-item px-5">
        <a (click)="downloadCSV()" class="menu-link">
          <span [inlineSVG]="STRING_CONSTANTS.ICON.IC_UPLOAD_FILE" class="svg-icon svg-icon-2 me-3"></span>
          <span>Generate CSV QR Code</span>
        </a>
      </div>
    </ng-container>

    <div *ngIf="privilegeEditProduct" class="menu-item px-5">
      <a (click)="onClickEditProduct()" class="menu-link">
        <span [inlineSVG]="STRING_CONSTANTS.ICON.IC_OUTLINE_EDIT" class="svg-icon svg-icon-2 me-3"></span>
        <span>Edit</span>
      </a>
    </div>

    <div *ngIf="privilegeUnpublishedProduct" class="menu-item px-5">
      <a class="menu-link" href="#">
        <span class="svg-icon svg-icon-2 me-3" inlineSVG="./assets/media/icons/ic_suspend.svg"></span>
        <span>Unpublished</span>
      </a>
    </div>
  </div>
</div>

<mat-tab-group mat-stretch-tabs="false" (selectedTabChange)="handleTabChange($event)" [selectedIndex]="tabIndex" animationDuration="0ms" class="line">
  <ng-container *ngFor="let tab of privilegeTabs.value">
    <mat-tab *ngIf="tab === 'TAB_PRODUCT_INFORMATION'" label="Informasi Produk">
      <ng-template matTabContent>
        <app-info-products
          (productData)="handleProductData($event)"
          (productDescription)="handleProductDescription($event)"
          *ngIf="tabIndex === 0"
          [id]="productId"
        ></app-info-products>
      </ng-template>
    </mat-tab>

    <mat-tab *ngIf="tab === 'TAB_DISTRIBUTOR_EXCLUSIVE'" label="Distributor Exclusive">
      <ng-template matTabContent>
        <app-distributor-exclusive [product_name]="detailProduct.value?.name" *ngIf="tabIndex === 1"></app-distributor-exclusive>
      </ng-template>
    </mat-tab>

    <mat-tab *ngIf="tab === 'TAB_VARIANT_INFORMATION'" label="Informasi Variant">
      <ng-template matTabContent>
        <app-variant-information *ngIf="tabIndex === 2" [Data]="detailProduct"></app-variant-information>
      </ng-template>
    </mat-tab>

    <mat-tab *ngIf="tab === 'TAB_HISTORY_QRCODE'" label="Histori QR Code">
      <ng-template matTabContent>
        <app-history-qr *ngIf="tabIndex === 3"></app-history-qr>
      </ng-template>
    </mat-tab>
  </ng-container>
</mat-tab-group>

<form (ngSubmit)="submitForm()" [formGroup]="formGroup" class="form">
  <app-modal #modalConfirm [callbackSubmit]="submitForm" [modalConfig]="modalConfig">
    <label class="mb-2">Input jumlah QR code yang ingin dicetak</label>
    <app-input-text [class]="'w-100'" [type]="'number'" formControlName="amount_qr_input" ngDefaultControl placeholder="Input jumlah QR Code "></app-input-text>
    <div class="d-flex align-items-center">
      <span [inlineSVG]="STRING_CONSTANTS.ICON.IC_INFO" class="svg-icon svg-icon-2 me-3"></span>
      <span>Setiap set akan mendapatkan 1pcs QR R1 & R2</span>
    </div>
  </app-modal>
</form>

<app-modal #modalConfirmSubmit [callbackSubmit]="onSubmitFormCode" [modalConfig]="modalConfigSubmit">
  <div class="text-center">
    Apakah anda yakin untuk membuat {{ valueSetQr }} set QR code
    <br />
    <strong> {{ detailProduct.value?.name }}? </strong>
  </div>
</app-modal>

<app-document-test [data]="listGenerateProduct" class="d-none"></app-document-test>
<!--<button #printQrcode [hidden]="true" [print]="['print-generate-barcode']">print</button>-->
<app-modal #modalLoading [modalConfig]="modalConfigLoading">
  <div class="d-flex align-items-center flex-column justify-content-center">
    <div class="spinner-border spinner-border-lg" role="status" style="width: 10rem; height: 10rem"></div>
    <div class="mt-2">Mohon tunggu, QR code sedang di generate</div>
  </div>
</app-modal>

<!--modal after approve-->
<app-modal #modalAfterGenereteCode [callbackSubmit]="downloadPrint" [modalConfig]="modalConfigAfterGenereteCode">
  <div class="d-flex flex-column justify-content-center align-items-center">
    <span [inlineSVG]="iconSuccess"></span>
    <div>QR Code berhasil di generate.</div>
  </div>
</app-modal>
